import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class InvoicesBillingService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination, group }) {
    const url = `/billing/v1/invoices`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination,
      group
    });
    return await this.get(resourceRoute);
  }
}

export default InvoicesBillingService;



// WEBPACK FOOTER //
// ./src/core/service/invoices-billing.service.js